import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import { trimProps } from '@components/library/helper';
import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface TertiaryIconButtonProps {
  height?: number;
  icon?: string;
  iconSize?: number;
  width?: number;
}

const TertiaryIconButton: FunctionComponent<TertiaryIconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const { height, style, width, } = props;
  const updatedStyles = (height || width) && {
    ...style,
    ...height && { height: `${height}px` },
    ...width && { minWidth: `${width}px` },
  };
  const baseProps = {
    ...updatedStyles ? trimProps(props, 'height,width') : props, // remove height and/or width
    ...updatedStyles && { style: updatedStyles },
    styleClassNames,
    variantName: 'tertiary-icon',
  };

  return <BaseButton {...baseProps} />;
};

export default TertiaryIconButton;
